import React from "react";

class Header extends React.Component {
  render() {
    return (
      <div className="pos-f-t">
        <nav className="navbar navbar-dark bg-info">
          <h1 className="title">Quotes?</h1>
        </nav>
      </div>
    );
  }
}

export default Header;
